import elements from './elements';
import state from './state';
import { startForm } from './welcome';
import { handleNavButtonDisplay } from './nav';

const moduleState = {
	init: false,
};

/**
 * @function resetState
 * @description Resets the progress and active field index states.
 *
 * @since 1.0.0
 *
 */
const resetState = () => {
	let progress = 1;
	elements.fields.forEach( ( field, index ) => {
		// Skip if field is hidden by conditional logic.
		if ( field.style.display === 'none' ) {
			return;
		}

		// If active step, set progress and active field index.
		if ( field.classList.contains( 'active-step' ) ) {
			state.progress = progress;
			state.activeFieldIndex = index;
			return;
		}

		progress++;
	} );
};

/**
 * @function setActiveIdsFromField
 * @description Curried function to set active IDs from the field provided.
 *
 * @param {boolean} isInit Whether conditional logic is init or not.
 *
 * @return {Function} The curried function to set active IDs from field.
 */
const setActiveIdsFromField = ( isInit ) => ( field, index ) => {
	if ( field.style.display === 'none' ) {
		// Remove this field ID from the list of active IDs.
		state.activeIds = state.activeIds.filter( ( currentId ) => currentId !== field.id );
		return;
	}

	// If is init, set active field index.
	if ( ! moduleState.init && isInit ) {
		moduleState.init = true;
		state.activeFieldIndex = index;
	}
	// If field ID is not in active IDs, add field ID.
	if ( ! state.activeIds.includes( field.id ) ) {
		state.activeIds = [ ...state.activeIds, field.id ];
	}
};

/**
 * @function handleApplyRulesEnd
 * @description Handler for the conditional logic apply rules end event.
 *
 * @since 1.0.0
 *
 * @param {Event} event The event object.
 */
const handleApplyRulesEnd = ( event ) => {
	const { detail: { isInit } } = event;

	elements.fields.forEach( setActiveIdsFromField( isInit ) );
	if ( isInit ) {
		startForm();
	}

	resetState();
	handleNavButtonDisplay();
};

/**
 * @function setupHooks
 * @description Sets up filters and actions for conditional logic.
 *
 * @since 1.0.0
 *
 */
const setupHooks = () => {
	document.addEventListener( 'gform/conditionalLogic/applyRules/end', handleApplyRulesEnd );
};

/**
 * @function init
 * @description Initializes conversational forms conditional logic hooks.
 *
 * @since 1.0.0
 *
 */
const init = () => {
	setupHooks();
};

export default init;
